import moment from 'moment';

export const employeeStatuses = [
  { value: '', label: 'Todos' },
  { value: 'activos', label: 'Activos' },
  { value: 'inactivos', label: 'Inactivos' }
];

export const workSchedules = [
  { value: '', label: 'Seleccione un periodo' },
  {
    value: [
      moment()
        .startOf('month')
        .format('DD/MM/YYYY'),
      moment()
        .endOf('month')
        .format('DD/MM/YYYY')
    ],
    label: 'Mes Actual'
  },
  {
    value: [
      moment()
        .subtract(1, 'months')
        .startOf('month')
        .format('DD/MM/YYYY'),
      moment()
        .subtract(1, 'months')
        .endOf('month')
        .format('DD/MM/YYYY')
    ],
    label: 'Mes Anterior'
  }
];
